import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import _ from "lodash";
import { Table, Row } from "reactstrap";
import { Container } from "reactstrap";
import { toastBigError, toastConfirm } from "components/utils/toasts";
import { cleanString } from "components/utils/cleanString";
import { paginate } from "components/utils/paginate";
import { getPedidos } from "services/pedidoService";
import { getConfig } from "config/config";
import PaginationControls from "components/PaginationControls/paginationControls";
import { capFirst } from "components/utils/capFirst";
import moment from "moment";
import "moment/locale/es.js";

const Pedidos = () => {
  const [allRecords, setAllRecords] = useState([]);
  const [mounted, setMounted] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortColumn, setSortColumn] = useState({ path: "descripcion", order: "asc" });
  const [searchQuery, setSearchQuery] = useState("");

  const config = getConfig();
  const history = useHistory();
  const pageSize = config.recordsPerPage;

  moment.locale("es", {
    week: {
      dow: 1, // for starrting day from monday
    },
  });

  const fetchData = async () => {
    try {
      const records = await getPedidos();
      if (records === "NETWORK ERROR") toastBigError("Error", "Error de Conexión");
      else setAllRecords(records);
    } catch {}
  };

  if (!mounted) {
    fetchData();
    setMounted(true);
  }

  const getPagedData = () => {
    let filtered = [];
    if (searchQuery.trim().length > 0) {
      filtered = allRecords.filter((m) => cleanString(m.descripcion).includes(cleanString(searchQuery)));
    } else {
      filtered = allRecords;
    }
    const ordered = _.orderBy(filtered, [sortColumn.path], [sortColumn.order]);
    const records = paginate(ordered, currentPage, pageSize);
    return { totalCount: filtered.length, records };
  };

  const { totalCount, records } = getPagedData();
  if (currentPage > Math.ceil(totalCount / pageSize) && totalCount > 0)
    setCurrentPage(Math.ceil(totalCount / pageSize));

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleView = (id) => {
    history.push({
      pathname: "/pedidos/" + id,
      state: { action: "C" },
    });
  };

  const labelPages = Math.ceil(totalCount / pageSize) > 1 ? currentPage + "/" + Math.ceil(totalCount / pageSize) : "";

  return mounted ? (
    <>
      <Container className="wrapper">
        <h2 className="mt-4 mb-4">Pedidos</h2>
        <Container>
          <Table hover responsive striped>
            <thead>
              <tr>
                <th style={{ width: "20%" }}>Fecha/Hora</th>
                <th style={{ width: "40%" }}>Sala</th>
                <th style={{ width: "40%" }}>Pedido Por</th>
              </tr>
            </thead>
            <tbody>
              {records.map((item) => (
                <tr key={Math.random()}>
                  <td className="clickable" onClick={() => handleView(item._id)}>
                    <span className="black">
                      {capFirst(moment(item.fecha).format("D [de] MMMM [de] YYYY - HH:mm"))}
                    </span>
                  </td>
                  <td className="clickable" onClick={() => handleView(item._id)}>
                    <span className="black">{item.sala.descripcion}</span>
                  </td>
                  <td className="clickable" onClick={() => handleView(item._id)}>
                    <span className="black">{item.user.nombre + " " + item.user.apellido}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Container>
        <Container>
          <Row className="justify-content-between align-items-center">
            <span>{labelPages}</span>
            <PaginationControls
              onPageChange={(page) => handlePageChange(page)}
              itemsCount={totalCount}
              pageSize={pageSize}
              currentPage={currentPage}
            />
          </Row>
        </Container>
      </Container>
    </>
  ) : (
    <></>
  );
};

export default Pedidos;
